const rootEl = document.documentElement;
const trigger = document.getElementById("nav-trigger");
const activeClass = "nav-open";
const primaryNav = document.getElementById("primary-nav");
const subnavOpenClass = "is-open";
const expandedAttr = "aria-expanded";

const init = () => {
    if (trigger !== null) {
        trigger.addEventListener("click", (e) => {
            rootEl.classList.toggle(activeClass);
        });
    }

    if (primaryNav !== null) {
        for (const item of primaryNav.querySelectorAll("[aria-haspopup]")) {
            item.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                const isExpanded = item.getAttribute(expandedAttr);
                const parent = item.parentElement;

                if (isExpanded === "true") {
                    // parent.classList.remove(subnavOpenClass);
                    // item.setAttribute(expandedAttr, "false");
                    closeNav();
                } else {
                    closeNav();
                    parent.classList.add(subnavOpenClass);
                    item.setAttribute(expandedAttr, "true");
                }
            });
        }
    }

    window.addEventListener("click", () => {
        closeNav();
    });
};

const closeNav = () => {
    for (const item of primaryNav.querySelectorAll("[aria-haspopup]")) {
        item.parentElement.classList.remove(subnavOpenClass);
        item.setAttribute(expandedAttr, "false");
    }
};

export default init;
